import React from "react";
import EditOrderModal from "@/modules/shared/orderProduction/EditOrderModal";
import { connect, ReactReduxContext } from "react-redux";
import type { Dispatch } from "redux";
import { SHOW_EDIT_COMMENT_MODAL } from "../reducers/planningTable";
import * as t from "@/lib/backend/manufacturing2.generated.types";
import { dispatchUpdateOrderComment } from "../reducers/linesOrders/orderCommentActions";

import type { Store } from "redux";
import type { ReduxState } from "../reducers/reducers";
import type { ShowEditCommentModal } from "../reducers/planningTable";
import type { ActionTypes } from "../reducers/reducers";

export const onSaveComment = (order_uuid: string, comment: string, store: Store<ReduxState>) => {
    dispatchUpdateOrderComment(store, order_uuid, comment);
};

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class PlanningTableEditModal extends React.Component<Props> {
    static contextType = ReactReduxContext;

    context!: React.ContextType<typeof ReactReduxContext>;

    onCloseEditModal = () => {
        this.props.reduxDispatch({
            type: SHOW_EDIT_COMMENT_MODAL,
            data: null,
        });
    };

    onSave = (order: t.IOrderModelBase | null) => {
        if (!order) {
            return;
        }
        onSaveComment(this.props.show_edit_comment_modal_order_uuid ?? "", order.order_comment, this.context.store);
    };

    render() {
        return (
            <EditOrderModal
                key={this.props.show_edit_comment_modal_order_uuid}
                show_modal={Boolean(this.props.show_edit_comment_modal_order_uuid)}
                onCloseModal={this.onCloseEditModal}
                onSave={this.onSave}
                order_uuid={this.props.show_edit_comment_modal_order_uuid ?? ""}
            />
        );
    }
}

const mapState = (state: ReduxState) => {
    const planning_table = state.gantt_chart_planning_table;
    return {
        show_edit_comment_modal_order_uuid: planning_table.show_edit_comment_modal_order_uuid,
    };
};
const mapDispatch = (dispatch: Dispatch<ShowEditCommentModal | ActionTypes>) => ({ reduxDispatch: dispatch });

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(PlanningTableEditModal);
